import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PostInspectionDiyAcceptPrice from "../post-inspection-diy-accept-price";
import priceFormatter from "../../../utils/helpers/price-formatter";
import PostInspectionDiyAuctionCard from "../post-inspection-diy-auction-card";

const AcceptPricePopup = ({
    priceAfterDeductions,
    carImage,
    title = "",
    setPopupContainerType
}) => {

    const sanitizedOfferedPrice = `₹${priceFormatter(priceAfterDeductions)}`;
    return (
        <React.Fragment>
            <div styleName={"styles.acceptPricePopup"}>
                {title && <h4>{title}</h4>}
                <PostInspectionDiyAuctionCard
                    carImage={carImage}
                    heading={"Final in-hand offer"}
                >
                    <>
                        {sanitizedOfferedPrice}
                        <h4>After deductions</h4>
                    </>
                </PostInspectionDiyAuctionCard>
            </div>
            <PostInspectionDiyAcceptPrice ctaText = {"Accept price"} isModal={true} onSuccess={setPopupContainerType} />
        </React.Fragment>
    );
};

AcceptPricePopup.propTypes = {
    priceAfterDeductions: PropTypes.any,
    carImage: PropTypes.string,
    title: PropTypes.string,
    setPopupContainerType: PropTypes.func
};

export default AcceptPricePopup;
